;(function(factory) {
    // conditional factory logic should be placed here.
    if (typeof Lum == 'undefined' || typeof jQuery == 'undefined') {
        var lmnInterval = setInterval(function(){
            if (typeof Lum != 'undefined' && typeof jQuery != 'undefined') {
                clearInterval(lmnInterval);
                factory(jQuery);
            }
        }, 100);
    } else {
        factory(jQuery);
    }
})(function($) {

    $('.js-ff-ajax-form').each(function(){
        lmn_ff_ajax_handle($(this), $(this).find('.ff-ajax-form-msg'));
    });


    function lmn_ff_ajax_handle(form_container, form_message_element){

        var submitting = false;
        var fform = $(form_container).find('form');

        
        $(fform).on('submit', function(){

            //reset the validation fields before submitting
            $(fform).find('.frm_form_field').each(function(){
                $(this).removeClass('frm_blank_field');
                $(this).find('.frm_error').remove();
            });
        
            if(!submitting){
        
                submitting = true;
                $(fform).find('.frm_submit').append('<div class="loader">Loading...</div>');
                $(this).find('.frm_button_submit').css('opacity', '0.2');
                
                var data = {
                    'action' : 'wpb_handle_fform',
                    'formData' : $(fform).serialize(),
                };
                
                $.ajax({
                    url: "/wp/wp-admin/admin-ajax.php",
                    data: data,
                    type: 'post',
                    dataType: 'json',
                    success: function (data) {

                        if(data.has_errors){

                            var errors_array = Object.keys(data.errors).map(function(key) {
                                return [String(key), data.errors[key]];
                            });

                            errors_array.forEach(function(currentValue){
                                var field_num = currentValue[0].split('field')[1];
                                var field_msg = currentValue[1];
                                
                                $(fform).find('#frm_field_'+ field_num +'_container').addClass('frm_blank_field');
                                $(fform).find('#frm_field_'+ field_num +'_container').append('<div class="frm_error">'+ field_msg +'</div>');
                            });

                        }else{

                            $(form_container).children().not(form_message_element).fadeOut(500, function(){
                                $(form_container).find(form_message_element).fadeIn(500);
                            });
                        }

                        var first_invalid_form = $(fform).find('.frm_blank_field').first().offset()!==undefined ? $(fform).find('.frm_blank_field').first().offset().top : $(form_container).offset().top;

                        $("html, body").stop().animate({scrollTop: first_invalid_form - ($('header').outerHeight() + 50)}, 800, 'swing');
        
                        submitting = false;

                        $(fform).find('.frm_submit .loader').remove();

                        $(form_container).find('.frm_button_submit').css('opacity', '1');
                    }
                });
            }
        
            return false;
        
        });

    }

});
